// extracted by mini-css-extract-plugin
export default {"container":"Sea-z","heading":"Tea-z","links":"Uea-z","linkBtn":"Vea-z","disabled":"Wea-z","linkUppercaseBold":"Xea-z","copy":"Yea-z","subCopy":"Zea-z"};